/** IANA zone for Pacific time — the zone MOPS operator-facing timestamps render in. */
export const PACIFIC_TIME_ZONE = 'America/Los_Angeles';

/**
 * Format an instant in a specific IANA time zone as `YYYY-MM-DD HH:mm:ss TZ`
 * (24-hour clock, zone abbreviation) — e.g. `2026-06-02 14:30:09 PDT`.
 *
 * The time zone is a **parameter**, not baked into the function, so this stays
 * reusable (pass {@link PACIFIC_TIME_ZONE} at the call site). DST is handled by
 * `Intl` — the same instant renders `PST` in winter and `PDT` in summer.
 */
export default function formatInstantInTimeZone(instant: string | Date, timeZone: string): string {
  const date = instant instanceof Date ? instant : new Date(instant);
  const parts = new Intl.DateTimeFormat('en-US', {
    timeZone,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hourCycle: 'h23',
    timeZoneName: 'short',
  }).formatToParts(date);
  const get = (type: Intl.DateTimeFormatPartTypes): string => parts.find((p) => p.type === type)?.value ?? '';
  return `${get('year')}-${get('month')}-${get('day')} ${get('hour')}:${get('minute')}:${get('second')} ${get('timeZoneName')}`;
}
